export default [
  {
    path: '/Preview',
    name: 'PreviewQuestionaire',
    component: () => import(/* webpackPrefetch: true */'@/modules/que/views/Preview'),
    props: (route) => {
      const { redirect } = route.query;
      return ({ redirect });
    },
  }
];
